import { Route, Routes } from "react-router-dom";
import LayoutContainer from "../containers/layout/LayoutContainer";
import { Home, RedirectPage, UsersPage } from "../pages/common";
import Cart from "../pages/buyer/cart/Cart";
import {
	BrandList,
	CreateBrand,
	CreateProduct,
	DashboardSeller,
	ProductList,
	UpdateBrand,
	UpdateProduct,
	SellerAccountInformation,
	Sales,
	SaleDetail,
	Items,
	Billing,
	LaboratoryRoutesPage,
	LaboratoryUserRoutesPage,
	UserDiscountsPage,
	LaboratoryAuditory,
	LaboratoryProductDiscountList,
	SellerWeb,
	SellerExpo,
	LaboratoryExpoEventList,
	LaboratoryCreateExpoEvent,
	LaboratoryUpdateExpoEvent,
	WebSellersDiscountsPage,
	LaboratoryCouponsList,
	LaboratoryDistributorResponse,
	GeneralConfig,
	ModuleErp,
	HomeMobile,
	CreateCombo,
	UpdateCombo,
	LaboratoryInitiativeList,
	LaboratoryCreateInitiative,
	LaboratoryUpdateInitiative,
	LaboratoryStatesAuditory,
	LaboratoryAlerts,
	ImportOrders,
	LaboratoryConfigs,
	HistoryImportOrders,
	UpdateFailedOrder,
	AgentTokenUsagePage,
	LaboratoryAgentsList,
	WhatsAppProductList,
} from "../pages/seller";
import AccountInformation from "../pages/buyer/account/update/AccountInformation";
import ProductDetail from "../pages/seller/product-detail/ProductDetail";
import UserProfile from "../pages/common/user-profile/UserProfile";
import {
	CreateDistributor,
	CreateMarketProduct,
	CreateMegaDistributor,
	DistributorList,
	IndexPage,
	MarketProductsIndex,
	RequestList,
	UpdateDistributor,
	UpdateLaboratory,
	UpdateMarketProduct,
	UpdateMegaDistributor,
	UpdateRequest,
	Import,
	DashboardOneMarket,
	Auditory,
	MarketUsersPage,
	MarketOrders,
	MarketOrderDetail,
	OneMarketSellerPage,
	MobileRequestList,
	UpdateMobileRequest,
	AsignPage,
	MarketPointOfSalePage,
	ClientPosList,
	UpdateClientPointOfSale,
	CreateClientPointOfSale,
	FeaturedIndex,
	GeneralPointsOfSale,
	PointOfSaleHistoryDetail,
	ImportGeneralPos,
	MarketRoutesPage,
	MarketUserRoutesPage,
	MarketUserDiscountsPage,
	SendedFiles,
	AuthUsersOneMarket,
	DistributorResponse,
	CreateFeaturedProduct,
	UpdateFeaturedProduct,
	MarketProductsDiscountsPage,
	MarketWebSellersDiscountsPage,
	MarketExpoEventList,
	MarketCreateExpoEvent,
	MarketUpdateExpoEvent,
	MarketCouponsList,
	MarketCreateCoupon,
	MarketUpdateCoupon,
	MarketMobileConfigsPage,
	MarketGeneralConfig,
	MarketGeneralPos,
	MarketGeneralPosToValidate,
	CreateMarketComboProduct,
	UpdateMarketComboProduct,
	CreateClient,
	UpdateClient,
	MarketClientsIndex,
	ClientContract,
	ContractReport,
	DistributorResponseCT,
	ModuleOrderStatesCheckpos,
	ChainList,
	CreateChain,
	UpdateChain,
	CodeChanges,
	MarketDistributorStatus,
	PaymentTermsList,
	CreatePaymentTerm,
	UpdatePaymentTerm,
	LaboratorySuggestionList,
	UpdateLaboratorySuggestion,
	CreateLaboratorySuggestion,
	LaboratoryList,
	SuggestedProductsDashboard,
	LaboratoryAgentList,
	LaboratoryPdvPoolPage,
	LaboratoryAgentConversationList,
	AgentConversations,
	LaboratoryAgentConfigsList,
	CreateAgentConfig,
	UpdateAgentConfig,
	LaboratoryAgentOrderList,
	AgentOrders,
	AgentPanelList,
	CreateAgent,
	UpdateAgent,
	TermsAndPolicy,
	LaboratoryMarketingList,
	LaboratoryMarketingAssets,
	ClientTemplatesAdminPage,
	IAPlanList,
	CreateIAPlan,
	UpdateIAPlan,
} from "../pages/admin";
import ProtectedRoute from "./ProtectedRoute";
import { useFilter } from "../../contexts/filterContext";
import { CONSTANTS } from "../../utils/constants";
import ModuleOrders from "../pages/seller/module-erp/components/module-orders/ModuleOrders";

export default function Main({ userdata, clientUser }) {
	const {
		setSelectedSeller,
		setSellerDashboardDisplay,
		setOrdersLabSellerId,
		setUserSellerId,
		sudoLabUser,
		sudoLabClient,
	} = useFilter();

	const getRedirectPath = () => {
		if (userdata.isOneMarket || userdata.isAgency) {
			return "/generalConfig";
		}
		if (userdata.isSeller && userdata.p_shop && !userdata.p_mobile) {
			setSelectedSeller(clientUser?.id);
			setOrdersLabSellerId(clientUser?.id);
			return "/admin/laboratorySellerWeb";
		}
		if (userdata.isSeller && userdata.p_shop && userdata.p_mobile) {
			setSelectedSeller(clientUser?.id);
			setOrdersLabSellerId(clientUser?.id);
			return "/admin/expoSellerWeb";
		}
		if (userdata.isSeller && !userdata.p_shop && userdata.p_mobile) {
			setSelectedSeller(clientUser?.id);
			setOrdersLabSellerId(clientUser?.id);
			//setSellerDashboardDisplay(CONSTANTS.DASHBOARD_MOBILE);
			return "/homeMobile";
		}
		if (userdata.isSeller && userdata.p_client) {
			return "/erp";
		}
		if (
			userdata.isOneMarket &&
			!userdata.p_client &&
			!userdata.p_users &&
			!userdata.p_products &&
			userdata.p_dashboard &&
			userdata.p_sales &&
			userdata.p_shop
		) {
			setUserSellerId(clientUser?.id);
		}
		return null;
	};

	const redirectPath = getRedirectPath();

	return (
		<LayoutContainer>
			<Routes>
				<Route
					path="/"
					element={
						<ProtectedRoute
							isAllowed={!redirectPath}
							redirectPath={redirectPath || "/"}
						>
							{/* <Home /> */}
							<div></div>
						</ProtectedRoute>
					}
				/>

				<Route path="/homeMobile">
					<Route index element={<HomeMobile clientId={userdata?.clientId} />} />
				</Route>

				<Route path="/product">
					<Route path=":id" element={<ProductDetail />} />
				</Route>

				<Route
					path="/generalConfig"
					element={
						<ProtectedRoute
							isAllowed={
								userdata &&
								((userdata.p_client &&
									(userdata.p_products || userdata.p_users)) ||
									userdata.isAgency)
							}
						/>
					}
				>
					<Route
						index
						element={
							userdata.isOneMarket && !sudoLabUser && !sudoLabClient ? (
								<MarketGeneralConfig userdata={userdata} />
							) : userdata.isSeller ||
							  userdata.isAgency ||
							  (sudoLabUser && sudoLabClient) ? (
								<GeneralConfig
									userdata={sudoLabUser ? sudoLabUser : userdata}
									clientContract={
										sudoLabClient
											? sudoLabClient.client.contract
											: clientUser?.client?.contract
									}
									clientId={
										sudoLabUser ? sudoLabUser.clientId : userdata?.clientId
									}
									clientName={
										sudoLabClient
											? sudoLabClient.client.slug
											: clientUser?.client?.slug
									}
								/>
							) : (
								<Home />
							)
						}
					/>
				</Route>

				<Route
					path="/erp"
					element={
						<ProtectedRoute
							isAllowed={userdata && userdata.p_dashboard && userdata.p_sales}
						/>
					}
				>
					<Route
						index
						element={
							userdata.isOneMarket && !sudoLabUser && !sudoLabClient ? (
								<div>Nothing to show</div>
							) : userdata.isSeller || (sudoLabUser && sudoLabClient) ? (
								<ModuleErp
									userdata={sudoLabUser ? sudoLabUser : userdata}
									clientContract={
										sudoLabClient
											? sudoLabClient.client.contract
											: clientUser?.client?.contract
									}
									clientId={
										sudoLabUser ? sudoLabUser.clientId : userdata?.clientId
									}
								/>
							) : (
								<Home />
							)
						}
					/>
				</Route>

				<Route
					path="/generalPosConfig"
					element={
						<ProtectedRoute isAllowed={userdata && userdata.isOneMarket} />
					}
				>
					<Route
						index
						element={
							userdata.isOneMarket &&
							((userdata.p_client && userdata.p_products) ||
								(!userdata.p_client &&
									!userdata.p_products &&
									userdata.p_dashboard)) ? (
								<MarketGeneralPos userdata={userdata} />
							) : userdata.isSeller ? (
								<Home />
							) : (
								<Home />
							)
						}
					/>
				</Route>

				<Route
					path="/generalPosToValidate"
					element={
						<ProtectedRoute isAllowed={userdata && userdata.isOneMarket} />
					}
				>
					<Route
						index
						element={
							userdata.isOneMarket &&
							!sudoLabUser &&
							!sudoLabClient &&
							((userdata.p_client && userdata.p_products) ||
								(!userdata.p_client &&
									!userdata.p_products &&
									userdata.p_dashboard)) ? (
								<MarketGeneralPosToValidate userdata={userdata} />
							) : userdata.isSeller ? (
								<Home />
							) : (
								<Home />
							)
						}
					/>
				</Route>

				<Route
					path="/orderStates"
					element={<ProtectedRoute isAllowed={userdata} />}
				>
					<Route
						index
						element={
							userdata.isOneMarket && !sudoLabUser && !sudoLabClient ? (
								<Home />
							) : userdata.isSeller || (sudoLabUser && sudoLabClient) ? (
								<LaboratoryStatesAuditory
									userdata={sudoLabUser ? sudoLabUser : userdata}
									clientContract={
										sudoLabClient
											? sudoLabClient.client.contract
											: clientUser?.client?.contract
									}
									clientId={
										sudoLabUser ? sudoLabUser.clientId : userdata?.clientId
									}
									userId={
										sudoLabUser
											? sudoLabUser
											: userdata.isSeller && userdata.p_sales
												? clientUser?.id
												: null
									}
								/>
							) : (
								<Home />
							)
						}
					/>
				</Route>

				<Route path="/redirect" element={<RedirectPage />}>
					<Route index path=":uri" element={<RedirectPage />} />
				</Route>

				<Route
					exact
					path="/cart"
					element={
						<ProtectedRoute
							redirectPath="/"
							isAllowed={
								userdata &&
								(userdata.p_shop || (!userdata.p_shop && userdata.p_mobile))
							}
						>
							<Cart />
						</ProtectedRoute>
					}
				/>

				<Route
					exact
					path="/marketSellerPage"
					element={
						<ProtectedRoute
							redirectPath="/"
							isAllowed={
								userdata.isOneMarket &&
								!sudoLabUser &&
								!sudoLabClient &&
								userdata.p_shop
							}
						>
							<OneMarketSellerPage />
						</ProtectedRoute>
					}
				/>

				<Route exact path="/profile" element={<UserProfile />} />

				<Route
					path="/admin/*"
					element={
						<Routes>
							<Route
								path="/items"
								element={
									<ProtectedRoute
										isAllowed={
											sudoLabUser
												? sudoLabUser.isSeller && sudoLabUser.p_products
												: userdata.isSeller && userdata.p_products
										}
									/>
								}
							>
								<Route
									index
									element={
										<Items
											clientId={
												sudoLabUser ? sudoLabUser.clientId : userdata?.clientId
											}
										/>
									}
								/>
							</Route>

							<Route
								path="/products"
								element={
									<ProtectedRoute
										isAllowed={
											sudoLabUser
												? sudoLabUser.isSeller && sudoLabUser.p_products
												: userdata.isSeller && userdata.p_products
										}
									/>
								}
							>
								<Route index element={<ProductList />} />
								<Route
									exact
									path="create"
									element={
										<CreateProduct
											clientId={
												sudoLabUser ? sudoLabUser.clientId : userdata?.clientId
											}
										/>
									}
								/>
								<Route
									path=":id"
									element={
										<UpdateProduct
											clientId={
												sudoLabUser ? sudoLabUser.clientId : userdata?.clientId
											}
										/>
									}
								/>
								<Route
									exact
									path="createCombo"
									element={
										<CreateCombo
											clientId={
												sudoLabUser ? sudoLabUser.clientId : userdata?.clientId
											}
										/>
									}
								/>
								<Route
									path="/products/combo/:id"
									element={
										<UpdateCombo
											clientId={
												sudoLabUser ? sudoLabUser.clientId : userdata?.clientId
											}
										/>
									}
								/>
							</Route>

							<Route
								path="/laboratorySellerWeb"
								element={
									<ProtectedRoute
										redirectPath="/"
										isAllowed={
											sudoLabUser
												? sudoLabUser.isSeller &&
													sudoLabUser.p_shop &&
													!sudoLabUser.p_mobile
												: userdata.isSeller &&
													userdata.p_shop &&
													!userdata.p_mobile
										}
									>
										<SellerWeb
											clientId={
												sudoLabUser ? sudoLabUser.clientId : userdata?.clientId
											}
										/>
									</ProtectedRoute>
								}
							/>

							<Route
								path="/expoSellerWeb"
								element={
									<ProtectedRoute
										redirectPath="/"
										isAllowed={
											sudoLabUser
												? sudoLabUser.isSeller &&
													sudoLabUser.p_shop &&
													sudoLabUser.p_mobile
												: userdata.isSeller &&
													userdata.p_shop &&
													userdata.p_mobile
										}
									>
										<SellerExpo
											clientId={
												sudoLabUser ? sudoLabUser.clientId : userdata?.clientId
											}
										/>
									</ProtectedRoute>
								}
							/>

							<Route
								path="/brands"
								element={
									<ProtectedRoute
										isAllowed={
											sudoLabUser
												? sudoLabUser.isSeller && sudoLabUser.p_products
												: userdata.isSeller && userdata.p_products
										}
									/>
								}
							>
								<Route
									index
									element={
										<BrandList
											clientId={
												sudoLabUser ? sudoLabUser.clientId : userdata?.clientId
											}
										/>
									}
								/>
								<Route
									exact
									path="create"
									element={
										<CreateBrand
											clientId={
												sudoLabUser ? sudoLabUser.clientId : userdata?.clientId
											}
										/>
									}
								/>
								<Route
									path=":id"
									element={
										<UpdateBrand
											clientId={
												sudoLabUser ? sudoLabUser.clientId : userdata?.clientId
											}
										/>
									}
								/>
							</Route>

							<Route
								path="/ventas"
								element={
									<ProtectedRoute
										isAllowed={
											sudoLabUser
												? sudoLabUser.isSeller && sudoLabUser.p_sales
												: userdata.isSeller && userdata.p_sales
										}
									/>
								}
							>
								<Route
									index
									element={
										<Sales
											clientId={
												sudoLabUser ? sudoLabUser.clientId : userdata?.clientId
											}
										/>
									}
								/>
								<Route
									path=":id"
									element={
										<SaleDetail
											clientId={
												sudoLabUser ? sudoLabUser.clientId : userdata?.clientId
											}
										/>
									}
								/>
							</Route>

							<Route
								path="/sellerOrders"
								element={
									<ProtectedRoute
										isAllowed={
											sudoLabUser
												? sudoLabUser.isSeller && sudoLabUser.p_sales
												: userdata.isSeller && userdata.p_sales
										}
									/>
								}
							>
								<Route
									index
									element={
										<ModuleOrders
											clientId={
												sudoLabUser ? sudoLabUser.clientId : userdata?.clientId
											}
											userId={
												userdata.isSeller && userdata.p_sales
													? clientUser?.id
													: null
											}
										/>
									}
								/>
							</Route>

							<Route
								path="/laboratoryAuditory"
								element={
									<ProtectedRoute
										isAllowed={
											sudoLabUser
												? sudoLabUser.isSeller && sudoLabUser.p_sales
												: userdata.isSeller && userdata.p_sales
										}
									/>
								}
							>
								<Route
									index
									element={
										<LaboratoryAuditory
											clientId={
												sudoLabUser ? sudoLabUser.clientId : userdata?.clientId
											}
										/>
									}
								/>
							</Route>

							<Route
								path="/importOrders"
								element={
									<ProtectedRoute
										isAllowed={
											sudoLabUser
												? sudoLabUser.isSeller && sudoLabUser.p_sales
												: userdata.isSeller && userdata.p_sales
										}
									/>
								}
							>
								<Route
									index
									element={
										<ImportOrders
											clientId={
												sudoLabUser ? sudoLabUser.clientId : userdata?.clientId
											}
										/>
									}
								/>
							</Route>

							<Route
								path="/importOrdersHistory"
								element={
									<ProtectedRoute
										isAllowed={
											sudoLabUser
												? sudoLabUser.isSeller && sudoLabUser.p_sales
												: userdata.isSeller && userdata.p_sales
										}
									/>
								}
							>
								<Route
									index
									element={
										<HistoryImportOrders
											clientId={
												sudoLabUser ? sudoLabUser.clientId : userdata?.clientId
											}
										/>
									}
								/>
								<Route
									path=":id"
									element={
										<UpdateFailedOrder
											clientId={
												sudoLabUser ? sudoLabUser.clientId : userdata?.clientId
											}
										/>
									}
								/>
							</Route>

							<Route
								path="/users"
								element={
									<ProtectedRoute
										isAllowed={
											sudoLabUser
												? sudoLabUser && sudoLabUser.p_users
												: userdata && userdata.p_users
										}
									/>
								}
							>
								<Route
									index
									element={
										<UsersPage
											clientId={
												sudoLabUser ? sudoLabUser.clientId : userdata.clientId
											}
										/>
									}
								/>
							</Route>

							<Route
								path="/dashboard"
								element={
									<ProtectedRoute
										isAllowed={
											userdata &&
											((!userdata.isOneMarket &&
												userdata.p_dashboard &&
												userdata.p_sales) ||
												(!userdata.isOneMarket &&
													!userdata.p_dashboard &&
													(userdata.p_shop || userdata.p_mobile)) ||
												(userdata.isOneMarket &&
													userdata.p_products &&
													userdata.p_dashboard &&
													userdata.p_sales) ||
												(userdata.isOneMarket &&
													userdata.p_client &&
													userdata.p_products &&
													userdata.p_sales) ||
												(userdata.isOneMarket &&
													userdata.p_dashboard &&
													userdata.p_sales &&
													!userdata.p_shop &&
													!userdata.p_mobile))
										}
									/>
								}
							>
								<Route
									index
									element={
										userdata.isOneMarket && !sudoLabUser && !sudoLabClient ? (
											<DashboardOneMarket />
										) : userdata.isSeller || (sudoLabUser && sudoLabClient) ? (
											<DashboardSeller
												clientId={
													sudoLabUser
														? sudoLabUser.clientId
														: userdata?.clientId
												}
												clientUser={sudoLabClient ? sudoLabClient : clientUser}
											/>
										) : (
											<Home />
										)
									}
								/>
							</Route>

							<Route
								path="/account"
								element={
									<ProtectedRoute isAllowed={userdata && userdata.p_client} />
								}
							>
								<Route
									index
									element={
										userdata.isSeller ? (
											<SellerAccountInformation />
										) : (
											<AccountInformation />
										)
									}
								/>
								<Route
									exact
									path="/account/billing"
									element={
										userdata?.isSeller ? (
											<Billing clientId={userdata?.clientId} />
										) : (
											<Home />
										)
									}
								/>
							</Route>

							<Route
								path="/distributors"
								element={
									<ProtectedRoute
										isAllowed={
											userdata.isOneMarket &&
											userdata.p_client &&
											userdata.p_users
										}
									/>
								}
							>
								<Route index element={<DistributorList />} />
								<Route exact path="create" element={<CreateDistributor />} />
								<Route path=":id" element={<UpdateDistributor />} />
								<Route exact path="asign" element={<AsignPage />} />
							</Route>

							<Route
								path="/chains"
								element={
									<ProtectedRoute
										isAllowed={
											userdata.isOneMarket &&
											userdata.p_client &&
											userdata.p_users
										}
									/>
								}
							>
								<Route index element={<ChainList />} />
								<Route exact path="create" element={<CreateChain />} />
								<Route path=":id" element={<UpdateChain />} />
							</Route>

							<Route
								path="/generalPointsOfSale"
								element={
									<ProtectedRoute
										isAllowed={
											userdata.isOneMarket &&
											userdata.p_client &&
											userdata.p_products &&
											userdata.p_dashboard
										}
									/>
								}
							>
								<Route index element={<GeneralPointsOfSale />} />
								<Route path=":id" element={<PointOfSaleHistoryDetail />} />
							</Route>

							<Route
								path="/marketProductsIndex"
								element={
									<ProtectedRoute
										isAllowed={userdata.isOneMarket && userdata.p_client}
									/>
								}
							>
								<Route index element={<MarketProductsIndex />} />
								<Route
									exact
									path="createMarketProduct"
									element={<CreateMarketProduct />}
								/>
								<Route
									exact
									path="createMarketComboProduct"
									element={<CreateMarketComboProduct />}
								/>
								<Route
									exact
									path="/marketProductsIndex/marketProduct/:id"
									element={<UpdateMarketProduct />}
								/>
								<Route
									exact
									path="/marketProductsIndex/marketComboProduct/:id"
									element={<UpdateMarketComboProduct />}
								/>
							</Route>

							<Route
								path="/marketPos"
								element={
									<ProtectedRoute
										isAllowed={
											(userdata.isOneMarket && userdata.p_users) ||
											(userdata.isOneMarket &&
												userdata.p_client &&
												userdata.p_products &&
												userdata.p_sales)
										}
									/>
								}
							>
								<Route index element={<MarketPointOfSalePage />} />
								<Route
									exact
									path="/marketPos/clientPos/:id"
									element={<ClientPosList />}
								/>
								<Route
									exact
									path="/marketPos/clientPointOfSale/:id"
									element={<UpdateClientPointOfSale />}
								/>
								<Route
									exact
									path="/marketPos/clientPointOfSale/create"
									element={<CreateClientPointOfSale />}
								/>
							</Route>

							<Route
								path="/marketUsers"
								element={
									<ProtectedRoute
										isAllowed={
											(userdata.isOneMarket && userdata.p_users) ||
											(userdata.isOneMarket &&
												userdata.p_client &&
												userdata.p_products &&
												userdata.p_sales)
										}
									/>
								}
							>
								<Route
									index
									element={
										<MarketUsersPage
											userdata={userdata}
											clientUser={clientUser}
										/>
									}
								/>
							</Route>

							<Route
								path="/import"
								element={
									<ProtectedRoute
										isAllowed={userdata.isOneMarket && userdata.p_client}
									/>
								}
							>
								<Route index element={<Import />} />
							</Route>

							<Route
								path="/marketWebSellers"
								element={
									<ProtectedRoute
										isAllowed={userdata.isOneMarket && userdata.p_client}
									/>
								}
							>
								<Route index element={<MarketWebSellersDiscountsPage />} />
							</Route>

							<Route
								path="/importGeneralPos"
								element={
									<ProtectedRoute
										isAllowed={
											userdata.isOneMarket &&
											userdata.p_client &&
											userdata.p_products &&
											userdata.p_dashboard
										}
									/>
								}
							>
								<Route index element={<ImportGeneralPos />} />
							</Route>

							<Route
								path="/marketOrders"
								element={
									<ProtectedRoute
										isAllowed={userdata.isOneMarket && userdata.p_sales}
									/>
								}
							>
								<Route index element={<MarketOrders />} />
								<Route path=":id" element={<MarketOrderDetail />} />
							</Route>

							<Route
								path="/marketRoutes"
								element={
									<ProtectedRoute
										isAllowed={userdata.isOneMarket && userdata.p_client}
									/>
								}
							>
								<Route index element={<MarketRoutesPage />} />
							</Route>

							<Route
								path="/mobileRequests"
								element={
									<ProtectedRoute
										isAllowed={
											userdata.isOneMarket &&
											((userdata.p_client && userdata.p_products) ||
												(!userdata.p_client &&
													!userdata.p_products &&
													userdata.p_dashboard))
										}
									/>
								}
							>
								<Route index element={<MobileRequestList />} />
								<Route path=":id" element={<UpdateMobileRequest />} />
							</Route>

							<Route
								path="/marketUserRoutes"
								element={
									<ProtectedRoute
										isAllowed={userdata.isOneMarket && userdata.p_client}
									/>
								}
							>
								<Route index element={<MarketUserRoutesPage />} />
							</Route>

							<Route
								path="/marketUserDiscounts"
								element={
									<ProtectedRoute
										isAllowed={userdata.isOneMarket && userdata.p_client}
									/>
								}
							>
								<Route index element={<MarketUserDiscountsPage />} />
							</Route>

							<Route
								path="/marketProductDiscounts"
								element={
									<ProtectedRoute
										isAllowed={userdata.isOneMarket && userdata.p_client}
									/>
								}
							>
								<Route index element={<MarketProductsDiscountsPage />} />
							</Route>

							<Route
								path="/marketMobileConfigs"
								element={
									<ProtectedRoute
										isAllowed={userdata.isOneMarket && userdata.p_client}
									/>
								}
							>
								<Route index element={<MarketMobileConfigsPage />} />
							</Route>

							<Route
								path="/laboratoryRoutes"
								element={
									<ProtectedRoute
										isAllowed={
											sudoLabUser
												? sudoLabUser.isSeller && sudoLabUser.p_client
												: userdata.isSeller && userdata.p_client
										}
									/>
								}
							>
								<Route
									index
									element={
										<LaboratoryRoutesPage
											clientId={
												sudoLabUser ? sudoLabUser.clientId : userdata?.clientId
											}
										/>
									}
								/>
							</Route>

							<Route
								path="/laboratoryEvents"
								element={
									<ProtectedRoute
										isAllowed={
											sudoLabUser
												? sudoLabUser.isSeller && sudoLabUser.p_client
												: userdata.isSeller && userdata.p_client
										}
									/>
								}
							>
								<Route
									index
									element={
										<LaboratoryExpoEventList
											clientId={
												sudoLabUser ? sudoLabUser.clientId : userdata?.clientId
											}
										/>
									}
								/>
								<Route
									exact
									path="create"
									element={
										<LaboratoryCreateExpoEvent
											clientId={
												sudoLabUser ? sudoLabUser.clientId : userdata?.clientId
											}
										/>
									}
								/>
								<Route
									path=":id"
									element={
										<LaboratoryUpdateExpoEvent
											clientId={
												sudoLabUser ? sudoLabUser.clientId : userdata?.clientId
											}
										/>
									}
								/>
							</Route>

							<Route
								path="/laboratoryCoupons"
								element={
									<ProtectedRoute
										isAllowed={userdata.isSeller && userdata.p_client}
									/>
								}
							>
								<Route
									index
									element={
										<LaboratoryCouponsList clientId={userdata?.clientId} />
									}
								/>
							</Route>

							<Route
								path="/laboratoryUserRoutes"
								element={
									<ProtectedRoute
										isAllowed={
											sudoLabUser
												? sudoLabUser.isSeller && sudoLabUser.p_client
												: userdata.isSeller && userdata.p_client
										}
									/>
								}
							>
								<Route
									index
									element={
										<LaboratoryUserRoutesPage
											clientId={
												sudoLabUser ? sudoLabUser.clientId : userdata?.clientId
											}
										/>
									}
								/>
							</Route>

							<Route
								path="/laboratoryProductDiscounts"
								element={
									<ProtectedRoute
										isAllowed={
											sudoLabUser
												? sudoLabUser.isSeller && sudoLabUser.p_client
												: userdata.isSeller && userdata.p_client
										}
									/>
								}
							>
								<Route
									index
									element={
										<LaboratoryProductDiscountList
											clientId={
												sudoLabUser ? sudoLabUser.clientId : userdata?.clientId
											}
										/>
									}
								/>
							</Route>

							<Route
								path="/laboratoryUserDiscounts"
								element={
									<ProtectedRoute
										isAllowed={
											sudoLabUser
												? sudoLabUser.isSeller && sudoLabUser.p_client
												: userdata.isSeller && userdata.p_client
										}
									/>
								}
							>
								<Route
									index
									element={
										<UserDiscountsPage
											clientId={
												sudoLabUser ? sudoLabUser.clientId : userdata?.clientId
											}
										/>
									}
								/>
							</Route>

							<Route
								path="/laboratoryWebSellerDiscounts"
								element={
									<ProtectedRoute
										isAllowed={
											sudoLabUser
												? sudoLabUser.isSeller && sudoLabUser.p_client
												: userdata.isSeller && userdata.p_client
										}
									/>
								}
							>
								<Route
									index
									element={
										<WebSellersDiscountsPage
											clientId={
												sudoLabUser ? sudoLabUser.clientId : userdata?.clientId
											}
										/>
									}
								/>
							</Route>

							<Route
								path="/featuredSettings"
								element={
									<ProtectedRoute
										isAllowed={userdata.isOneMarket && userdata.p_client}
									/>
								}
							>
								<Route index element={<FeaturedIndex />} />
								<Route
									exact
									path="/featuredSettings/createFeaturedProducts"
									element={<CreateFeaturedProduct />}
								/>
								<Route
									exact
									path="/featuredSettings/featuredProduct/:id"
									element={<UpdateFeaturedProduct />}
								/>
							</Route>

							<Route
								path="/distributorsIndex"
								element={
									<ProtectedRoute
										isAllowed={
											userdata.isOneMarket &&
											userdata.p_client &&
											userdata.p_users
										}
									/>
								}
							>
								<Route index element={<IndexPage />} />
								<Route
									exact
									path="createMegaDistributor"
									element={<CreateMegaDistributor />}
								/>
								<Route
									exact
									path="/distributorsIndex/megaDistributor/:id"
									element={<UpdateMegaDistributor />}
								/>
								<Route
									exact
									path="/distributorsIndex/laboratory/:id"
									element={<UpdateLaboratory />}
								/>
							</Route>

							<Route
								path="/clients"
								element={
									<ProtectedRoute
										isAllowed={
											(userdata.isOneMarket && userdata.p_users) ||
											(userdata.isOneMarket &&
												userdata.p_client &&
												userdata.p_products &&
												userdata.p_sales)
										}
									/>
								}
							>
								<Route index element={<MarketClientsIndex />} />
								<Route exact path="create" element={<CreateClient />} />
								<Route path=":id" element={<UpdateClient />} />
								<Route
									exact
									path="/clients/contractEdit/:id"
									element={<ClientContract />}
								/>
								<Route
									exact
									path="/clients/contractReport/:id"
									element={<ContractReport />}
								/>
							</Route>

							<Route
								path="/auditory"
								element={
									<ProtectedRoute
										isAllowed={
											(userdata.isOneMarket &&
												userdata.p_products &&
												userdata.p_dashboard &&
												userdata.p_sales) ||
											(userdata.isOneMarket &&
												userdata.p_dashboard &&
												userdata.p_sales &&
												!userdata.p_shop &&
												!userdata.p_mobile)
										}
									/>
								}
							>
								<Route index element={<Auditory />} />
							</Route>

							<Route
								path="/sendedFiles"
								element={<ProtectedRoute isAllowed={userdata.isOneMarket} />}
							>
								<Route index element={<SendedFiles />} />
							</Route>

							<Route
								path="/marketAuths"
								element={
									<ProtectedRoute
										isAllowed={
											userdata.isOneMarket &&
											userdata.p_client &&
											userdata.p_users
										}
									/>
								}
							>
								<Route index element={<AuthUsersOneMarket />} />
							</Route>

							<Route
								path="/distributorResponse"
								element={<ProtectedRoute isAllowed={userdata.isOneMarket} />}
							>
								<Route index element={<DistributorResponse />} />
							</Route>

							<Route
								path="/distributorResponseCT"
								element={<ProtectedRoute isAllowed={userdata.isOneMarket} />}
							>
								<Route index element={<DistributorResponseCT />} />
							</Route>

							<Route
								path="/orderStateCT"
								element={<ProtectedRoute isAllowed={userdata.isOneMarket} />}
							>
								<Route index element={<ModuleOrderStatesCheckpos />} />
							</Route>

							<Route
								path="/laboratoryDistributorResponse"
								element={
									<ProtectedRoute
										isAllowed={userdata.isSeller && userdata.p_client}
									/>
								}
							>
								<Route
									index
									element={
										<LaboratoryDistributorResponse
											clientId={userdata?.clientId}
										/>
									}
								/>
							</Route>

							<Route
								path="/expoEventOT"
								element={
									<ProtectedRoute
										isAllowed={userdata.isOneMarket && userdata.p_client}
									/>
								}
							>
								<Route index element={<MarketExpoEventList />} />
								<Route
									exact
									path="create"
									element={<MarketCreateExpoEvent />}
								/>
								<Route path=":id" element={<MarketUpdateExpoEvent />} />
							</Route>

							<Route
								path="/marketCoupons"
								element={
									<ProtectedRoute
										isAllowed={userdata.isOneMarket && userdata.p_client}
									/>
								}
							>
								<Route index element={<MarketCouponsList />} />
								<Route exact path="create" element={<MarketCreateCoupon />} />
								<Route path=":id" element={<MarketUpdateCoupon />} />
							</Route>

							<Route
								path="/laboratoryInitiatives"
								element={
									<ProtectedRoute
										isAllowed={
											sudoLabUser
												? sudoLabUser.isSeller && sudoLabUser.p_client
												: userdata.isSeller && userdata.p_client
										}
									/>
								}
							>
								<Route
									index
									element={
										<LaboratoryInitiativeList
											clientId={
												sudoLabUser ? sudoLabUser.clientId : userdata?.clientId
											}
										/>
									}
								/>
								<Route
									exact
									path="create"
									element={
										<LaboratoryCreateInitiative
											clientId={
												sudoLabUser ? sudoLabUser.clientId : userdata?.clientId
											}
										/>
									}
								/>
								<Route
									path=":id"
									element={
										<LaboratoryUpdateInitiative
											clientId={
												sudoLabUser ? sudoLabUser.clientId : userdata?.clientId
											}
										/>
									}
								/>
							</Route>

							<Route
								path="/laboratoryAlerts"
								element={
									<ProtectedRoute
										isAllowed={
											sudoLabUser
												? sudoLabUser.isSeller && sudoLabUser.p_client
												: userdata.isSeller && userdata.p_client
										}
									/>
								}
							>
								<Route
									index
									element={
										<LaboratoryAlerts
											clientId={
												sudoLabUser ? sudoLabUser.clientId : userdata?.clientId
											}
										/>
									}
								/>
							</Route>

							<Route
								path="/laboratoryConfigs"
								element={
									<ProtectedRoute
										isAllowed={
											sudoLabUser
												? sudoLabUser.isSeller && sudoLabUser.p_client
												: userdata.isSeller && userdata.p_client
										}
									/>
								}
							>
								<Route
									index
									element={
										<LaboratoryConfigs
											clientId={
												sudoLabUser ? sudoLabUser.clientId : userdata?.clientId
											}
										/>
									}
								/>
							</Route>

							<Route
								path="/codeChanges"
								element={
									<ProtectedRoute
										isAllowed={
											(userdata.isOneMarket && userdata.p_users) ||
											(userdata.isOneMarket &&
												userdata.p_client &&
												userdata.p_products &&
												userdata.p_sales)
										}
									/>
								}
							>
								<Route
									index
									element={
										<CodeChanges userdata={userdata} clientUser={clientUser} />
									}
								/>
							</Route>

							<Route
								path="/distributorStatus"
								element={
									<ProtectedRoute
										isAllowed={
											(userdata.isOneMarket && userdata.p_users) ||
											(userdata.isOneMarket &&
												userdata.p_client &&
												userdata.p_products &&
												userdata.p_sales)
										}
									/>
								}
							>
								<Route
									index
									element={
										<MarketDistributorStatus
											userdata={userdata}
											clientUser={clientUser}
										/>
									}
								/>
							</Route>

							<Route
								path="/paymentTerms"
								element={
									<ProtectedRoute
										isAllowed={
											userdata.isOneMarket &&
											userdata.p_client &&
											userdata.p_users
										}
									/>
								}
							>
								<Route index element={<PaymentTermsList />} />
								<Route exact path="create" element={<CreatePaymentTerm />} />
								<Route path=":id" element={<UpdatePaymentTerm />} />
							</Route>

							<Route
								path="/laboratorySuggestions"
								element={
									<ProtectedRoute
										isAllowed={
											(userdata.isOneMarket &&
												userdata.p_client &&
												userdata.p_users) ||
											(sudoLabUser
												? sudoLabUser.isSeller && sudoLabUser.p_client
												: userdata.isSeller && userdata.p_client)
										}
									/>
								}
							>
								<Route
									index
									element={
										<LaboratorySuggestionList
											clientId={
												userdata.isOneMarket && !sudoLabUser
													? null
													: sudoLabUser
														? sudoLabUser.clientId
														: userdata?.clientId
											}
										/>
									}
								/>
								<Route
									exact
									path="create"
									element={
										<CreateLaboratorySuggestion
											clientId={
												userdata.isOneMarket && !sudoLabUser
													? null
													: sudoLabUser
														? sudoLabUser.clientId
														: userdata?.clientId
											}
										/>
									}
								/>
								<Route
									path=":id"
									element={
										<UpdateLaboratorySuggestion
											clientId={
												userdata.isOneMarket && !sudoLabUser
													? null
													: sudoLabUser
														? sudoLabUser.clientId
														: userdata?.clientId
											}
										/>
									}
								/>
							</Route>

							<Route
								path="/suggestedProducts"
								element={
									<ProtectedRoute
										isAllowed={
											(userdata.isOneMarket &&
												userdata.p_client &&
												userdata.p_users) ||
											(sudoLabUser
												? sudoLabUser.isSeller && sudoLabUser.p_client
												: userdata.isSeller && userdata.p_client)
										}
									/>
								}
							>
								<Route
									index
									element={
										<LaboratoryList
											clientId={
												userdata.isOneMarket && !sudoLabUser
													? null
													: sudoLabUser
														? sudoLabUser.clientId
														: userdata?.clientId
											}
										/>
									}
								/>
								<Route path=":id" element={<SuggestedProductsDashboard />} />
							</Route>

							<Route
								path="/laboratoryAgentPool"
								element={
									<ProtectedRoute
										isAllowed={
											(userdata.isOneMarket &&
												userdata.p_client &&
												userdata.p_users) ||
											(sudoLabUser
												? sudoLabUser.isSeller && sudoLabUser.p_client
												: userdata.isSeller && userdata.p_client)
										}
									/>
								}
							>
								<Route
									index
									element={
										<LaboratoryAgentList
											clientId={
												userdata.isOneMarket && !sudoLabUser
													? null
													: sudoLabUser
														? sudoLabUser.clientId
														: userdata?.clientId
											}
										/>
									}
								/>
								<Route
									path=":id"
									element={
										<LaboratoryPdvPoolPage
											isSystemAdmin={
												userdata.isOneMarket && !sudoLabUser
													? true
													: sudoLabUser
														? false
														: userdata?.isOneMarket
											}
										/>
									}
								/>
							</Route>

							<Route
								path="/laboratoryAgentConversations"
								element={
									<ProtectedRoute
										isAllowed={
											(userdata.isOneMarket &&
												userdata.p_client &&
												userdata.p_users) ||
											(sudoLabUser
												? sudoLabUser.isSeller && sudoLabUser.p_client
												: userdata.isSeller && userdata.p_client)
										}
									/>
								}
							>
								<Route
									index
									element={
										<LaboratoryAgentConversationList
											clientId={
												userdata.isOneMarket && !sudoLabUser
													? null
													: sudoLabUser
														? sudoLabUser.clientId
														: userdata?.clientId
											}
										/>
									}
								/>
								<Route path=":id" element={<AgentConversations />} />
							</Route>

							<Route
								path="/laboratoryAgentConfigs"
								element={
									<ProtectedRoute
										isAllowed={
											(userdata.isOneMarket &&
												userdata.p_client &&
												userdata.p_users) ||
											(sudoLabUser
												? sudoLabUser.isSeller && sudoLabUser.p_client
												: userdata.isSeller && userdata.p_client)
										}
									/>
								}
							>
								<Route
									index
									element={
										<LaboratoryAgentConfigsList
											clientId={
												userdata.isOneMarket && !sudoLabUser
													? null
													: sudoLabUser
														? sudoLabUser.clientId
														: userdata?.clientId
											}
										/>
									}
								/>
								<Route
									exact
									path="create"
									element={
										<CreateAgentConfig
											clientId={
												userdata.isOneMarket && !sudoLabUser
													? null
													: sudoLabUser
														? sudoLabUser.clientId
														: userdata?.clientId
											}
										/>
									}
								/>
								<Route
									path=":id"
									element={
										<UpdateAgentConfig
											clientId={
												userdata.isOneMarket && !sudoLabUser
													? null
													: sudoLabUser
														? sudoLabUser.clientId
														: userdata?.clientId
											}
										/>
									}
								/>
							</Route>

							<Route
								path="/laboratoryAgentOrders"
								element={
									<ProtectedRoute
										isAllowed={
											(userdata.isOneMarket &&
												userdata.p_client &&
												userdata.p_users) ||
											(sudoLabUser
												? sudoLabUser.isSeller && sudoLabUser.p_client
												: userdata.isSeller && userdata.p_client)
										}
									/>
								}
							>
								<Route
									index
									element={
										<LaboratoryAgentOrderList
											clientId={
												userdata.isOneMarket && !sudoLabUser
													? null
													: sudoLabUser
														? sudoLabUser.clientId
														: userdata?.clientId
											}
										/>
									}
								/>
								<Route path=":id" element={<AgentOrders />} />
							</Route>

							<Route
								path="/agentPanel"
								element={
									<ProtectedRoute
										isAllowed={
											userdata.isOneMarket &&
											userdata.p_client &&
											userdata.p_users
										}
									/>
								}
							>
								<Route index element={<AgentPanelList />} />
								<Route exact path="create" element={<CreateAgent />} />
								<Route path=":id" element={<UpdateAgent />} />
							</Route>

							<Route
								path="/laboratoryMarketing"
								element={
									<ProtectedRoute
										isAllowed={
											(userdata.isOneMarket &&
												userdata.p_client &&
												userdata.p_users) ||
											(sudoLabUser
												? sudoLabUser.isSeller && sudoLabUser.p_client
												: userdata.isSeller && userdata.p_client)
										}
									/>
								}
							>
								<Route
									index
									element={
										<LaboratoryMarketingList
											clientId={
												userdata.isOneMarket && !sudoLabUser
													? null
													: sudoLabUser
														? sudoLabUser.clientId
														: userdata?.clientId
											}
										/>
									}
								/>
								<Route path=":id" element={<LaboratoryMarketingAssets />} />
							</Route>

							<Route
								path="/agentTemplates"
								element={
									<ProtectedRoute
										isAllowed={
											userdata.isOneMarket &&
											userdata.p_client &&
											userdata.p_users
										}
									/>
								}
							>
								<Route
									index
									element={
										<ClientTemplatesAdminPage
											clientId={
												userdata.isOneMarket && !sudoLabUser
													? null
													: sudoLabUser
														? sudoLabUser.clientId
														: userdata?.clientId
											}
										/>
									}
								/>
							</Route>

							<Route
								path="/laboratoryAgentTokens"
								element={
									<ProtectedRoute
										isAllowed={
											(userdata.isOneMarket &&
												userdata.p_client &&
												userdata.p_users) ||
											(sudoLabUser
												? sudoLabUser.isSeller && sudoLabUser.p_client
												: userdata.isSeller && userdata.p_client)
										}
									/>
								}
							>
								<Route
									index
									element={
										<AgentTokenUsagePage
											clientId={
												userdata.isOneMarket && !sudoLabUser
													? null
													: sudoLabUser
														? sudoLabUser.clientId
														: userdata?.clientId
											}
										/>
									}
								/>
							</Route>

							<Route
								path="/iaPlans"
								element={
									<ProtectedRoute
										isAllowed={
											userdata.isOneMarket &&
											userdata.p_client &&
											userdata.p_users
										}
									/>
								}
							>
								<Route index element={<IAPlanList />} />
								<Route exact path="create" element={<CreateIAPlan />} />
								<Route path=":id" element={<UpdateIAPlan />} />
							</Route>

							<Route
								path="/laboratoryAgentProducts"
								element={
									<ProtectedRoute
										isAllowed={
											(userdata.isOneMarket &&
												userdata.p_client &&
												userdata.p_users) ||
											(sudoLabUser
												? sudoLabUser.isSeller && sudoLabUser.p_client
												: userdata.isSeller && userdata.p_client)
										}
									/>
								}
							>
								<Route
									index
									element={
										<LaboratoryAgentsList
											clientId={
												userdata.isOneMarket && !sudoLabUser
													? null
													: sudoLabUser
														? sudoLabUser.clientId
														: userdata?.clientId
											}
										/>
									}
								/>
								<Route
									path=":id"
									element={
										<WhatsAppProductList
											clientId={
												userdata.isOneMarket && !sudoLabUser
													? null
													: sudoLabUser
														? sudoLabUser.clientId
														: userdata?.clientId
											}
										/>
									}
								/>
							</Route>

							<Route path="*" element={<div>404</div>} />
						</Routes>
					}
				/>

				<Route
					path="*"
					element={
						<main style={{ padding: "1rem" }}>
							<p>There's nothing here!</p>
						</main>
					}
				/>
			</Routes>
		</LayoutContainer>
	);
}
